'use strict';

module.exports = {
    loadVideo: function () {
        const $video = $('.js-videoControl');
        let videoDataAttr;

        if (window.isDesktop) {
            videoDataAttr = 'data-src-desktop';
        }
        else {
            videoDataAttr = 'data-src-mobile';
        }

        $video.each(function () {
            const self = $(this);
            if (!self.closest('.slick-cloned').length > 0) {
                let src = self.find('source');
                if (src) {
                    src.each(function () {
                        $(this).attr('src', $(this).attr(videoDataAttr));
                    });
                    self.get(0).load();
                }
            }
        });
    },
};